
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for-sale/[...search-path]",
      function () {
        return require("private-next-pages/for-sale/[...search-path]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/for-sale/[...search-path]"])
      });
    }
  